export const processHtmlDefinition = (htmlDefinition = '') => {
  if (!htmlDefinition) return []

  return htmlDefinition.split(/<\/?p>/g).filter((p) => p.trim())
}
